import i18next from 'i18next';

i18next.addResources('es_CL', 'OrdersTableHeader', {
  order: 'Pedido',
  idClient: 'ID de pedido y cliente',
  remainingTime: 'Tiempo Restante',
  modality: 'Tipo de entrega',
  state: 'Estado',
  quantity: 'Items',
  totalPrice: 'Total',
  paymentMethod: 'Tipo de pago',
  dateTime: 'Fecha y hora de entrega',
  hour: 'Hora',
  print: '',
  details: '',
  actions: 'Acciones',
  posId: 'POS ID'
});

i18next.addResources('es_CR', 'OrdersTableHeader', {
  order: 'Pedido',
  idClient: 'ID de pedido y cliente',
  remainingTime: 'Tiempo Restante',
  modality: 'Tipo de entrega',
  state: 'Estado',
  quantity: 'Items',
  totalPrice: 'Total',
  paymentMethod: 'Tipo de pago',
  dateTime: 'Fecha y hora de entrega',
  hour: 'Hora',
  print: '',
  details: '',
  actions: 'Acciones',
  posId: 'POS ID'
});
